var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCircleGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 0.366C3.5 0.366 0.672 3.194 0.672 6.68C0.672 10.18 3.5 13.008 7 13.008C10.486 13.008 13.314 10.18 13.314 6.68C13.314 3.194 10.486 0.366 7 0.366ZM7 1.444C9.884 1.444 12.236 3.796 12.236 6.68C12.236 9.578 9.884 11.93 7 11.93C4.102 11.93 1.75 9.578 1.75 6.68C1.75 3.796 4.102 1.444 7 1.444Z",
    fill: "#0FA44A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleGreen);
export default __webpack_public_path__ + "static/media/circle-green.7f26203adf1f8ed6f1a7fdf227ef162f.svg";
export { ForwardRef as ReactComponent };